import JSONPretty from 'react-json-pretty';

export default {
  className: "RWMApiLog",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "functionName",
  		type: "string"
    },
    {
      columnName: "params",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('error_data')) {
          value = object.get('error_data');

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "code",
  		type: "string"
    },
    {
      columnName: "message",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('message')) {
          value = object.get('message');
          
          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "error_data",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('error_data')) {
          value = object.get('error_data');
          
          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "json_parse_error",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('json_parse_error')) {
          value = object.get('json_parse_error');

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "response_data",
  		type: "string",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('response_data')) {
          value = object.get('response_data');
          
          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/RWMApiLog_schema.js